<template>
    <div>
        <header-signature v-if="salesPitchDto.title" :text="salesPitchDto.title" class="pb-1" />

        <div class="row">
            <div v-for="(pitch, index) in salesPitchDto.pitches" :key="index" class="col-12 col-md-4">
                <div v-if="pitch">
                    <div class="h4 mb-auto" v-html="pitch.title" />
                    <div class="alert-container ps-0">
                        <p class="alert ob1-alert-normal align-items-start">
                            <span
                                class="alert-icon pitch-icon"
                                :class="[pitch.iconName]"
                                aria-hidden="true"
                            />
                            <span class="ob1-alert-title text-gray3" v-html="pitch.descriptionHtml" />
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import HeaderSignature from "../../common/components/vue/HeaderSignature.vue";

export default {
    components: {HeaderSignature},
    props: {
        salesPitchDto: {
            type: Object,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>

.pitch-icon {
    font-size: 29px;
    margin-right: 5px;
}

</style>
